import * as React from 'react';
import { Messages } from '../../../../../codegen/Localize';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import {componentRegistryEntry} from '../../SettingsComponentRegistryFunctions';
import {FormikCheckbox} from '../../../../../commonInfra/components/FormikCheckbox';
import {TextLinkWidget} from '@tableau/widgets';
import {learnMoreStyle} from '../../../../styles/CommonStyles';
import {HelpService} from '../../../../../commonInfra/services/HelpService';

export const REMOTE_QUERYING_ENABLED_FIELD = 'settings.siteAdminBridgeSettings.remoteQueryingEnabled';

export function BridgePoolingSection() {
  return (
    <SettingsSection title={Messages.siteRemoteAgentSettingsAgentsPooling()}
                     testId={'bridge-pooling-section'}
                     description={renderDescription()}>

      <FormikCheckbox name={REMOTE_QUERYING_ENABLED_FIELD}
                      label={Messages.remoteAgentsAllowPoolingSiteSettingCheckbox()}
                      testId={'remote-querying-enabled'}>

      </FormikCheckbox>
    </SettingsSection>
  );
}

function renderDescription() {
  return <>
    <span>{Messages.siteRemoteAgentSettingsAgentsPooling_description()}</span>
    <TextLinkWidget testId={'bridge-pooling-learn-more'}
                    className={learnMoreStyle}
                    href={HelpService.getServerHelpUrlByCategory('bridge-pooling')}
                    target={'_blank'}>
      {Messages.siteRemoteAgentSettingsLearnMore()}
    </TextLinkWidget>
  </>;
}
/* for registering the component in settings registry */
export const BridgePoolingSectionSpecs = componentRegistryEntry({
  name: 'BridgePoolingSection',
  component: BridgePoolingSection
});
